<template>
  <div class="tab mgh-0 mgt-20px">
    <ul>
      <router-link
        v-for="tab in tabs"
        :key="tab.name"
        :to="{ name: tab.name }"
        :class="{ 'text-access-no-permission': !checkPermissions(tab.perm) }">
        <li :class="{ 'is-active': $router.currentRoute.name === tab.name }">
          {{ $t(tab.label) }}
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { BON_EXPEDITION, ORDRE_TRAVAIL_EXPEDITION } from '@/configuration/logistique/permissionsLogistiqueConf';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'OngletList',
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    tabs() {
      return [
        {
          name: 'l.logistique.ordre_travail_expedition',
          label: 'listBonExpedition.onglet.expedition',
          perm: ORDRE_TRAVAIL_EXPEDITION.lecture,
        },
        {
          name: 'l.logistique.bon_expedition',
          label: 'listBonExpedition.onglet.bonExpedition',
          perm: BON_EXPEDITION.lecture,
        },
      ];
    },
  },
};
</script>
